import React, {Component} from 'react'
import {connect} from 'react-redux'
import {api} from '../../../../../../api/index'
import Select from 'react-select';
import DateTimePicker from 'material-ui-datetimepicker';
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog';
import 'react-select/dist/react-select.css';
import axios from 'axios'
import {config} from "../../../../../../config/index"
import {loadUsers} from "../../../../../../api/users";
import {TextField} from 'material-ui';
import Toggle from 'material-ui/Toggle';


class PromotionGeneralBrandedComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			options: [],
			minEndDate: Date.now(),
			users: []
		};

		this.setSearchQuery = this.setSearchQuery.bind(this);
		this.setAuthorsQuery = this.setAuthorsQuery.bind(this);
		this.handleStartDateChange = this.handleStartDateChange.bind(this);
		this.handleEndDateChange = this.handleEndDateChange.bind(this);
		this.getAuthors = this.getAuthors.bind(this);
		this.handleState = this.handleState.bind(this);
	}

	handleState( event )  {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		api.promotions.handleState( name, value );
	}

	setSearchQuery(value) {
		api.promotions.handleState('postIds', value);
	}

	setAuthorsQuery(value) {
		api.promotions.handleState('authorIds', value);
	}

	componentDidMount() {
		loadUsers();
	}

	getPosts(input, callback) {
		let cancel;

		if ( input.length < 4 ) {
			return;
		}

		return axios.get(config.postSearch.url + '?s=' + input, )
			.then( ( response ) => {
				return new Promise((resolve, reject) => {
					let i = 0;
					let options = [];

					if (response.data.length > 0) {
						response.data.map((item) => {

							let obj = {
								ID: item.ID,
								post_title: item.post_title
							};

							options.push(obj);

							if (options.length === response.data.length) {
								resolve(options);
							}
						})
					} else {
						resolve(options);
					}


				}).then(options => {
					return {
						options: options
					};

				})
			})
	}


	getAuthors(input, callback) {
		let users = [];
		let options = [];

		return new Promise( ( resolve, reject ) => {
			let i = 0;
			for ( const user of this.props.users.users ) {

				users.push({
					ID: user.key,
					name: user.name
				});

				if ( ++i === this.props.users.users.length ) {
					resolve({
						options: users
					})
				}
			}
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			...this.state,
			minEndDate: props.promotion.startDateTimeStamp,
			users: props.users.users
		});
	}

	handleStartDateChange = ( dateTime ) => {
		const timeStamp = new Date( dateTime ).getTime();

		api.promotions.handleState( 'startDateTimeStamp', timeStamp );
	};

	handleEndDateChange = ( dateTime ) => {
		const timeStamp = new Date( dateTime ).getTime();

		api.promotions.handleState( 'endDateTimeStamp', timeStamp );
	};

	toggleHideBrandedInfo( isChecked ) {
		api.promotions.handleState( 'hideBrandedInfo', isChecked );
	}

	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-6 cell">
					<label>
						Startdatum
						<DateTimePicker
							onChange={this.handleStartDateChange}
							DatePicker={DatePickerDialog}
							TimePicker={TimePickerDialog}
							format='DD MMM YYYY HH:mm'
							timeFormat="24hr"
							fullWidth={true}
							value={new Date(this.props.promotion.startDateTimeStamp)}
							datePickerMode={'landscape'}
						/>
					</label>
				</div>
				<div className="medium-6 cell">
					<label>
						Einddatum
						<DateTimePicker
							onChange={this.handleEndDateChange}
							DatePicker={DatePickerDialog}
							TimePicker={TimePickerDialog}
							format='DD MMM YYYY HH:mm'
							timeFormat="24hr"
							fullWidth={true}
							value={undefined !== this.props.promotion.endDateTimeStamp && 0 !== this.props.promotion.endDateTimeStamp && this.props.promotion.endDateTimeStamp !== null ? new Date(this.props.promotion.endDateTimeStamp) : ''}
							minDate={this.state.minEndDate}
						/>
					</label>
				</div>
				<div className="cell medium-6">
					<label>
						Verberg de bedrijfs en auteurs informatie in het artikel.
						<Toggle
							label={`Informatie wordt ${(false === this.props.promotion.hideBrandedInfo || undefined === this.props.promotion.hideBrandedInfo ? `wel` : 'niet')} getoond in het artikel`}
							labelPosition={'right'}
							onToggle={(event, isInputChecked) => this.toggleHideBrandedInfo(isInputChecked)}
							toggled={this.props.promotion.hideBrandedInfo}
						/>
					</label>
				</div>

				<div className="cell medium-6">
					<label>
						Bedrijfs URL (Indien niet ingevuld, pakt het systeem de URL uit de bedrijvengids)
						<TextField
							value={this.props.promotion.companyUrl}
							onChange={this.handleState}
							name="companyUrl"
							fullWidth={true}
						/>
					</label>
				</div>

				<div className="medium-4 cell">
					<label>
						Koppelen aan posts
						<Select.Async
							multi={true}
							valueKey="ID"
							labelKey="post_title"
							loadOptions={this.getPosts}
							value={this.props.promotion.postIds}
							onChange={this.setSearchQuery}
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Auteurs
						<Select.Async
							multi={true}
							valueKey="ID"
							labelKey="name"
							loadOptions={this.getAuthors}
							value={this.props.promotion.authorIds}
							onChange={this.setAuthorsQuery}
							autoBlur={true}
						/>
					</label>
				</div>
				<div className="medium-4 cell">
					<label>
						Label
						<TextField
							placeholder={'Branded/Promoted'}
							value={this.props.promotion.label}
							onChange={this.handleState}
							name="label"
							fullWidth={true}
						/>
					</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		promotion: state.promotion,
		users: state.users
	}
}

export default connect(mapStateToProps, {
	loadUsers
})(PromotionGeneralBrandedComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/branded.js